import "./cardComponent.scss";
import Card from '@mui/material/Card';

interface CardComponentProps {
    className?: string;
}

const CardComponent = (props: React.PropsWithChildren<CardComponentProps>) => {

    const {className, children} = props;

    return (
        <Card className={`card-component ${className}`} raised={false}>
            {children}
        </Card>
    );
};

export default CardComponent;